import { inject, Injectable } from '@angular/core'
import { AppDownloadService } from '@ftr/api-core'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { map, Observable } from 'rxjs'
import { getAccessNavItemsGroup } from '../access-nav-items'
import { ADMIN_NAV_GROUP } from '../admin-nav-items'
import { SideNavProviderResult } from '../courts-side-nav-items.provider'
import { PLANS_NAV_GROUP } from '../plans-nav-items'
import { REQUEST_NAV_ITEMS_GROUP } from '../request-nav-items'
import { getPublicHelpSupportNavItem } from '../side-nav-item'

@Injectable({
  providedIn: 'root',
})
export class PublicSideNavItemsProvider {
  private readonly store = inject(Store)
  private readonly appDownloadService = inject(AppDownloadService)

  provide(): Observable<SideNavProviderResult> {
    return this.store.select(UserState.isLoggedIn).pipe(
      map(isLoggedIn => ({
        navGroups: isLoggedIn
          ? [REQUEST_NAV_ITEMS_GROUP, getAccessNavItemsGroup(), ADMIN_NAV_GROUP]
          : [REQUEST_NAV_ITEMS_GROUP, PLANS_NAV_GROUP],
        footerItems: [getPublicHelpSupportNavItem(this.appDownloadService.getStandaloneAppLink())],
      })),
    )
  }
}
